import { Component, EventEmitter, Input, Output, ViewChild, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { Logger } from '../../../../logging/default-log.service';
import { PendingOrder } from '../../../../classes/pending.order';
import { PendingOrderService } from '../../../../service/pending.order.service';
import { OrderTranslationsComponent } from '../../order.translations.component';
import { ApplicationService } from '../../../../service/application.service';
import { SlicePipe } from '@angular/common';
import { PendingOrderRowComponent } from './pending.order.row.component';
import { SalespersonTelephoneComponent } from '../../salesperson.telephone.component';

/**
 * Works with the same data as ActiveOrder, but to make sure everything is separated and still readable,
 * we've introduced a separate service and pojo.
 *
 * @author evandongen
 */
@Component({
    selector: 'pending-orders',
    templateUrl: 'pending.orders.component.html',
    standalone: true,
    imports: [OrderTranslationsComponent, RouterLink, SalespersonTelephoneComponent, PendingOrderRowComponent, SlicePipe]
})
export class PendingOrdersComponent {
  private pendingOrderService = inject(PendingOrderService);
  private applicationService = inject(ApplicationService);
  private router = inject(Router);
  private logger = inject(Logger);

  @ViewChild(OrderTranslationsComponent, { static: true })
  orderTranslationsComponent: OrderTranslationsComponent;

  @Input() maxAmount: number;
  @Output() startNewOrderClickEvent = new EventEmitter();
  pendingOrders: Array<PendingOrder>;
  noPendingOrders: boolean = false;
  loading: boolean = true;

  constructor() {
    this.pendingOrderService.getPendingOrders().subscribe(
      orders => this.setPendingOrders(orders),
      error => this.logger.error('Failed to get pending orders', error)
    );
  }

  /**
   * Opens the popup for a new order and listens for a succesful close to redirect.
   *
   */
  startNewOrder() {
    this.startNewOrderClickEvent.emit();

    this.applicationService.openPopup(() => {
      this.router.navigate(['/products']);
      this.applicationService.closePopup();
    });
  }

  private setPendingOrders(pendingOrders: Array<PendingOrder>) {
    this.pendingOrders = pendingOrders;
    this.noPendingOrders = pendingOrders.length === 0;
    this.loading = false;
  }
}
